import { render, staticRenderFns } from "./BaseTab.vue?vue&type=template&id=7c3618ec&scoped=true"
import script from "./BaseTab.vue?vue&type=script&lang=js"
export * from "./BaseTab.vue?vue&type=script&lang=js"
import style0 from "./BaseTab.vue?vue&type=style&index=0&id=7c3618ec&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3618ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c3618ec')) {
      api.createRecord('7c3618ec', component.options)
    } else {
      api.reload('7c3618ec', component.options)
    }
    module.hot.accept("./BaseTab.vue?vue&type=template&id=7c3618ec&scoped=true", function () {
      api.rerender('7c3618ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tab/BaseTab.vue"
export default component.exports